import { useRef as e } from "react";

var o = function o() {
  var n = e(null),
      r = e(null);
  return {
    inputRef: n,
    wrapperRef: r
  };
};

export { o as useRangeRef };